import { getCustomerOrdersById } from 'api/customers';
import { PERMISSIONS } from 'constants/permissions';
import { useHasAnyOfPermissions } from 'hooks/useHasPermission';
import usePagination from 'hooks/usePagination';
import React, { useEffect } from 'react';
import { errorHandling, getData } from 'utils';
import { captureException } from 'utils/errors';
import Table from '../Overview/Table';

function OrdersTab({ customer }) {
  const [orders, setOrders] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const hasCustomerAccess = useHasAnyOfPermissions([PERMISSIONS.CUSTOMERS]);

  const getCustomerOrders = () => {
    if (!hasCustomerAccess) return;
    setLoading(true);
    getCustomerOrdersById(customer.id, page)
      .then((res) => {
        const data = getData(res);
        const results = data?.data?.results ?? data?.results ?? [];
        setOrders(Array.isArray(results) ? results : []);
        setPagination({
          count: getData(res)?.count,
          next: getData(res)?.next,
          previous: getData(res)?.previous,
        });
        setLoading(false);
      })
      .catch((e) => {
        captureException(e);
        setLoading(false);
        errorHandling(e);
      });
  };

  const { page, setPage, pagination, setPagination, paginationEl } = usePagination(
    getCustomerOrders,
    loading,
  );

  useEffect(() => {
    if (hasCustomerAccess && customer?.id) {
      getCustomerOrders();
    }
  }, [hasCustomerAccess, customer?.id]);

  if (!hasCustomerAccess) {
    return null;
  }

  return (
    <div className="table-box">
      <div className="details-title">Orders history</div>
      <Table
        loading={loading}
        pagination={pagination}
        items={orders}
        refetch={getCustomerOrders}
      />
      <div className="pagination">{paginationEl}</div>
    </div>
  );
}

export default OrdersTab;
